module.exports = __webpack_public_path__ + "img/freespins_retrigger.57077c61.png";